import { produce } from 'immer';
import { CONFIG } from '../config/config';
import { COLOR_NAMES, COLORS } from '../config/constants';
import { RESOURCES } from '../config/resources';
import { ACTION_TYPES, POST_TYPES } from '../types/postsTypings';
import { TASK_STATES, TASK_TYPES } from '../types/projectTypings';
import { DateService } from './DateService';

export const MIME_TYPES = {
  abs: 'audio/x-mpeg',
  ai: 'application/postscript',
  aif: 'audio/x-aiff',
  aifc: 'audio/x-aiff',
  aiff: 'audio/x-aiff',
  aim: 'application/x-aim',
  art: 'image/x-jg',
  asf: 'video/x-ms-asf',
  asx: 'video/x-ms-asf',
  au: 'audio/basic',
  avi: 'video/x-msvideo',
  avx: 'video/x-rad-screenplay',
  bcpio: 'application/x-bcpio',
  bin: 'application/octet-stream',
  bmp: 'image/bmp',
  body: 'text/html',
  cdf: 'application/x-cdf',
  cer: 'application/pkix-cert',
  class: 'application/java',
  cpio: 'application/x-cpio',
  csh: 'application/x-csh',
  css: 'text/css',
  dib: 'image/bmp',
  doc: 'application/msword',
  dtd: 'application/xml-dtd',
  dv: 'video/x-dv',
  dvi: 'application/x-dvi',
  eot: 'application/vnd.ms-fontobject',
  eps: 'application/postscript',
  etx: 'text/x-setext',
  exe: 'application/octet-stream',
  gif: 'image/gif',
  gtar: 'application/x-gtar',
  gz: 'application/x-gzip',
  hdf: 'application/x-hdf',
  hqx: 'application/mac-binhex40',
  htc: 'text/x-component',
  htm: 'text/html',
  html: 'text/html',
  ief: 'image/ief',
  jad: 'text/vnd.sun.j2me.app-descriptor',
  jar: 'application/java-archive',
  java: 'text/x-java-source',
  jnlp: 'application/x-java-jnlp-file',
  jpe: 'image/jpeg',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  js: 'application/javascript',
  jsf: 'text/plain',
  json: 'application/json',
  jspf: 'text/plain',
  kar: 'audio/midi',
  latex: 'application/x-latex',
  m3u: 'audio/x-mpegurl',
  mac: 'image/x-macpaint',
  man: 'text/troff',
  mathml: 'application/mathml+xml',
  me: 'text/troff',
  mid: 'audio/midi',
  midi: 'audio/midi',
  mif: 'application/x-mif',
  mov: 'video/quicktime',
  movie: 'video/x-sgi-movie',
  mp1: 'audio/mpeg',
  mp2: 'audio/mpeg',
  mp3: 'audio/mpeg',
  mp4: 'video/mp4',
  mpa: 'audio/mpeg',
  mpe: 'video/mpeg',
  mpeg: 'video/mpeg',
  mpega: 'audio/x-mpeg',
  mpg: 'video/mpeg',
  mpv2: 'video/mpeg2',
  ms: 'application/x-wais-source',
  nc: 'application/x-netcdf',
  oda: 'application/oda',
  odb: 'application/vnd.oasis.opendocument.database',
  odc: 'application/vnd.oasis.opendocument.chart',
  odf: 'application/vnd.oasis.opendocument.formula',
  odg: 'application/vnd.oasis.opendocument.graphics',
  odi: 'application/vnd.oasis.opendocument.image',
  odm: 'application/vnd.oasis.opendocument.text-master',
  odp: 'application/vnd.oasis.opendocument.presentation',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odt: 'application/vnd.oasis.opendocument.text',
  otg: 'application/vnd.oasis.opendocument.graphics-template',
  oth: 'application/vnd.oasis.opendocument.text-web',
  otp: 'application/vnd.oasis.opendocument.presentation-template',
  ots: 'application/vnd.oasis.opendocument.spreadsheet-template',
  ott: 'application/vnd.oasis.opendocument.text-template',
  ogx: 'application/ogg',
  ogv: 'video/ogg',
  oga: 'audio/ogg',
  ogg: 'audio/ogg',
  otf: 'application/x-font-opentype',
  spx: 'audio/ogg',
  flac: 'audio/flac',
  anx: 'application/annodex',
  axa: 'audio/annodex',
  axv: 'video/annodex',
  xspf: 'application/xspf+xml',
  pbm: 'image/x-portable-bitmap',
  pct: 'image/pict',
  pdf: 'application/pdf',
  pgm: 'image/x-portable-graymap',
  pic: 'image/pict',
  pict: 'image/pict',
  pls: 'audio/x-scpls',
  png: 'image/png',
  pnm: 'image/x-portable-anymap',
  pnt: 'image/x-macpaint',
  ppm: 'image/x-portable-pixmap',
  ppt: 'application/vnd.ms-powerpoint',
  pps: 'application/vnd.ms-powerpoint',
  ps: 'application/postscript',
  psd: 'image/vnd.adobe.photoshop',
  qt: 'video/quicktime',
  qti: 'image/x-quicktime',
  qtif: 'image/x-quicktime',
  ras: 'image/x-cmu-raster',
  rdf: 'application/rdf+xml',
  rgb: 'image/x-rgb',
  rm: 'application/vnd.rn-realmedia',
  roff: 'text/troff',
  rtf: 'application/rtf',
  rtx: 'text/richtext',
  sfnt: 'application/font-sfnt',
  sh: 'application/x-sh',
  shar: 'application/x-shar',
  sit: 'application/x-stuffit',
  snd: 'audio/basic',
  src: 'application/x-wais-source',
  sv4cpio: 'application/x-sv4cpio',
  sv4crc: 'application/x-sv4crc',
  svg: 'image/svg+xml',
  svgz: 'image/svg+xml',
  swf: 'application/x-shockwave-flash',
  t: 'text/troff',
  tar: 'application/x-tar',
  tcl: 'application/x-tcl',
  tex: 'application/x-tex',
  texi: 'application/x-texinfo',
  texinfo: 'application/x-texinfo',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  tr: 'text/troff',
  tsv: 'text/tab-separated-values',
  ttf: 'application/x-font-ttf',
  txt: 'text/plain',
  ulw: 'audio/basic',
  ustar: 'application/x-ustar',
  vxml: 'application/voicexml+xml',
  xbm: 'image/x-xbitmap',
  xht: 'application/xhtml+xml',
  xhtml: 'application/xhtml+xml',
  xls: 'application/vnd.ms-excel',
  xml: 'application/xml',
  xpm: 'image/x-xpixmap',
  xsl: 'application/xml',
  xslt: 'application/xslt+xml',
  xul: 'application/vnd.mozilla.xul+xml',
  xwd: 'image/x-xwindowdump',
  vsd: 'application/vnd.visio',
  wav: 'audio/x-wav',
  wbmp: 'image/vnd.wap.wbmp',
  wml: 'text/vnd.wap.wml',
  wmlc: 'application/vnd.wap.wmlc',
  wmls: 'text/vnd.wap.wmlsc',
  wmlscriptc: 'application/vnd.wap.wmlscriptc',
  wmv: 'video/x-ms-wmv',
  woff: 'application/font-woff',
  woff2: 'application/font-woff2',
  wrl: 'model/vrml',
  wspolicy: 'application/wspolicy+xml',
  z: 'application/x-compress',
  zip: 'application/zip'
};

export const MULTIPART_HEADERS = { headers: { 'content-type': 'multipart/form-data' } };

export const PROD = 'production';

export const immerMiddleware = (config: any) => (set: any, get: any, api: any) => config((fn: any) => set(produce(fn)), get, api);

export const getRandomNumber = () => {
  return Math.floor(Math.random() * 99999 + 10000);
};

export const toFixed = (num: number, prc: number = 2) => {
  return num.toFixed(2);
};

export const getFilePath = (type: string, file: string) => {
  if (type === POST_TYPES.GIF) {
    return file;
  }
  return CONFIG.FILES_URL + type + '/' + file;
};

export const getUserImage = (image: any) => {
  return { uri: !!image ? CONFIG.FILES_URL + 'users/' + image : RESOURCES.USER };
};

export const getTimelineImage = (file: any) => {
  return CONFIG.FILES_URL + 'timeline/' + file;
};

export const getChatsImage = (image: any) => {
  return CONFIG.FILES_URL + 'chats/' + image;
};

export const removeLineBreaks = (str: string) => {
  return str.replace(/[\r\n]+/gm, '');
};

export const isMine = (myUuid: string, frndUuid: string) => {
  return myUuid === frndUuid;
};

export const getNotificationsText = (type: string) => {
  switch (type) {
    case ACTION_TYPES.POST_LIKE:
      return 'liked your post';
    case ACTION_TYPES.POST_COMMENT:
      return 'commented your post';
    case ACTION_TYPES.POST_SAVE:
      return 'saved your post';
    case ACTION_TYPES.USER_FOLLOW:
      return 'started following you';
    case ACTION_TYPES.USER_VIEW:
      return 'viewed your profile';
    case ACTION_TYPES.POST_VOTE:
      return 'voted on your poll';
    case ACTION_TYPES.GROUP_FOLLOW:
      return 'started following your group';
    case ACTION_TYPES.PROJECT_INVITE:
      return 'invited you to manage a project';
    case ACTION_TYPES.PROJECT_COMMENT:
      return 'commented on a project you manage';
    default:
      return 'has some action on your profile';
  }
};

export const hasMoreItems = (items: any, page: number) => {
  return items.length % 20 === 0 && (page - 1) * 20 === items.length;
};

export const getMessagesRoom = (user1: string, user2: string) => {
  return `${user1}:${user2}`;
};

export const createError = (status: number, message: string) => {
  return { status, message };
};

export const getFileExtension = (filename: string) => {
  return filename?.split('.')?.pop()?.toLowerCase() || '';
};

// Mobile dark mode colors
export const getPrimaryColor = (colors: any) => ({ color: colors.primary });
export const getTextColor = (colors: any) => ({ color: colors.text });
export const getBGColor = (colors: any) => ({ backgroundColor: colors.background });
export const getItemBGColor = (colors: any) => ({ backgroundColor: colors.card });
export const getBorderColor = (colors: any) => ({ borderColor: colors.border, borderWidth: 1 });
export const getDarkBorderColor = (colors: any) => ({ borderColor: colors.darkBorder, borderWidth: 1 });
export const getNotificationColor = (colors: any) => ({ borderColor: colors.notification });

export const getTextInputStyles = (gs: any, theme: any) => [
  gs.textInput,
  getItemBGColor(theme.colors),
  getTextColor(theme.colors),
  getBorderColor(theme.colors)
];

export const calcMediaHeight = (isVideo: boolean, width: number, height: number) => {
  const actual = (+height / +width) * 100;
  const final = isVideo && actual > 130 ? 130 : actual;
  return `${final}%`;
};

export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const capitalizeFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getRandomColor = () => {
  const colors = Object.values(COLOR_NAMES as any);
  return colors[Math.floor(Math.random() * colors.length)];
};

export const getSpecificColor = (name: string) => {
  return COLORS[name];
};

export const getColorByState = (state: string) => {
  switch (state) {
    case TASK_STATES.TODO:
      return getSpecificColor(COLOR_NAMES.YELLOW);
    case TASK_STATES.PROGRESS:
      return getSpecificColor(COLOR_NAMES.GREEN);
    case TASK_STATES.REVIEW:
      return getSpecificColor(COLOR_NAMES.BLUE);
    case TASK_STATES.COMPLETED:
      return getSpecificColor(COLOR_NAMES.ORANGE);
    case TASK_TYPES.TASK:
      return getSpecificColor(COLOR_NAMES.BLUE);
    case TASK_TYPES.BUG:
      return getSpecificColor(COLOR_NAMES.RED);
    case TASK_TYPES.FEATURE:
      return getSpecificColor(COLOR_NAMES.GREEN);
    case TASK_TYPES.INFO:
      return getSpecificColor(COLOR_NAMES.PURPLE);
    case TASK_TYPES.SUPPORT:
      return getSpecificColor(COLOR_NAMES.YELLOW);
  }
};

export const formatTaskDue = (due: string) => {
  const date = new Date(due);
  return DateService.getFormattedDate(date);
};

export const clearLineBreaks = (value: string) => {
  return value && value.replace(/(\r\n|\n|\r)/gm, ' ').trim();
};

export const checkForSubString = (target, value) => {
  return (target + '').toLowerCase().includes(value.toLowerCase());
};

export const extendFormData = (formData, data) => {
  for (let key in data) {
    formData.append(key, JSON.stringify(data[key] || ''));
  }
  return formData;
};

export const extractFormData = data => {
  for (let key in data) {
    data[key] = JSON.parse(data[key]);
  }
  return data;
};

export const getUniqueFileName = () => {
  return `NJ${Date.now()}${Math.floor(Math.random() * 99999) + 10000}`;
};

export const getFileName = (fileName: string) => {
  return `${getUniqueFileName()}.${getFileExtension(fileName)}`;
};

export const getMimeType = (fileName: string) => {
  return MIME_TYPES[getFileExtension(fileName)];
};

export const isValidUrl = (str: string) => {
  try {
    new URL(str);
    return true;
  } catch (err) {
    return false;
  }
};

export const formatSelectedTags = tags => {
  return tags.map((option: any) => {
    const color = getRandomColor();
    return {
      name: option.label,
      color: option.color || color
    };
  });
};
